
<template>
    <div class="footer-home">
        <!--<div class="footer-home__water"></div>-->
        <div class="footer-home__wrapper">
            <!--<a href="">
                <img class="footer-home__wrapper-image" src="../assets/img/footer_home/page-2-bg@2x.png">
            </a>-->
            <div class="footer-home__wrapper-content">
                <!--<div class="footer-home__leaf">
                    <img class="footer-home__leaf-image" src="../assets/img/footer_home/leaf@3x.png">
                </div>-->
                <div class="footer-home__content-wrapper">
                    <div class="footer-home__content-title">Manifesto</div>
                    <p class="footer-home__content-text">
                        Böyle harcamaya devam edersek, Türkiye'nin suyu yakın gelecekte tükenebilir.
                        <span></span>
                        Bugün tasarruf yapmaya başlamazsak, yarın tasarruf yapacağımız suyumuz olmayabilir.
                        <span></span>
                        Bugün duştan bulaşığa tüm alışkanlıklarımızı yeniden gözden geçirme vakti.
                        <span></span>
                        Gün harekete geçme günü. Yarının suyunu kurtarmak için, hemen. Bugün.
                    </p>
                    <div class="footer-home__content-links">
                        <a class="footer-home__content-link" href="https://www.finish.com.tr/" target="_blank">
                            <img src="@/assets/navigation/finish-logo@3x.png" alt="">
                        </a>
                        <a class="footer-home__content-link" href="https://www.natgeotv.com/tr" target="_blank">
                            <img src="@/assets/navigation/national-geographic-blacklogo@3x.png" alt="">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "FooterHome",
        props: [],
    }
</script>

<style lang="scss">
    .footer-home {
        display: flex;
        flex-direction: column;
        width: 100%;
        margin-top: 100px;

        &__water {
            display: flex;
            width: 100%;
            height: 463px;
            background-image: url('../assets/img/footer_home/page-5-line-water@3x.png');
            background-size: cover;
            background-position: 0px -120px;
            object-fit: contain;
            mix-blend-mode: multiply;
            background-color: white;

            @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                display: none;
            }

            @media (min-device-width: 768px) and (max-device-width: 1920px) {
                height: 320px;
            }
        }

        &__wrapper {
            display: flex;
            width: 100%;
            height: 900px;
            margin-top: -1px;
            justify-content: center;
            align-items: center;
            position: relative;
            background-color: white;
            background: url('../assets/img/footer_home/manifesto.jpg');
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
            
            @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                height: 1300px;
            }

            @media (min-device-width: 768px) and (max-device-width: 1920px) {
                height: 900px;
            }

            &-image {
                position: absolute;
                left: 0px;
                top: 0px;
                width: 100%;
                z-index: 1;
                background: white;

                @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                    bottom: 0px;
                    top: auto;
                }

                @media (min-device-width: 768px) and (max-device-width: 1920px) {
                    bottom: 0px;
                    top: auto;
                }
            }

            &-content {
                display: flex;
                position: absolute;
                left: 0px;
                right: 0px;
                margin: 0px auto;
                z-index: 2;
                width: 100%;
                //top: 50px;
                justify-content: center;
                height: calc(100% - 50px);
                align-items: center;
                @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                    flex-direction: column;
                    width: 100%;
                    top: 40px;
                    justify-content: center;
                    align-items: center;
                }
            }
        }

        &__leaf {
            display: flex;
            width: 412px;

            &-image {
                width: 100%;
                object-fit: contain;
                margin-bottom: auto;
            }

            @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                margin-bottom: 40px;
                margin-top: 50px;
                width: 450px;
                height: 300px;
            }
        }

        &__content-wrapper {
            display: flex;
            margin-left: 30px;
            flex-direction: column;
            //width: calc(100% - 412px);
            transform: translateY(-30%);
            @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                width: 100%;
                margin-left: 0px;
                justify-content: center;
                align-items: center;
            }

        }

        &__content {

            &-title {
                display: flex;
                font-size: 25px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                color: #037996;
                
                @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                    font-size: 45px;
                    text-shadow: 0px 0px 3px #0379b7;
                }

            }

            &-text {
                display: flex;
                font-size: 14px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                color: #037996;
                flex-direction: column;

                @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                    text-align: center;
                    font-size: 35px;
                    padding: 0px 50px;
                    text-shadow: 0px 0px 3px #0379b7;
                }

                & > span {
                    display: block;
                    height: 20px;

                    @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                        display: none;
                    }
                }
            }

            &-links {
                display: flex;
                align-items: center;
            }

            &-link:nth-child(1) {
                width: 60px;
                margin-right: 35px;

                @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                    width: 150px;
                }

                & > img {
                    width: 100%;
                }
            }

            &-link:nth-child(2) {
                width: 100px;

                @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                    width: 220px;
                }

                & > img {
                    width: 100%;
                }
            }
        }
    }
</style>
